export const color = {
    dark: {
        primary: "#F27801",
        secondary: "#343443",
        transparent: "transparent",
        background: {
            default: "#0E091C",
            input: "#2D2C35",
            badge: "#2D2C35",
            app: "#020210",
            menu: "#34383E",
            backdrop: "#000000BF",
        },
        text: {
            primary: "#FAFAFA",
            secondary: "#8F8F92",
        },
        up: {
            main: "#45B879",
            darker: "rgba(69, 184, 121, 0.02)",
            lighter: "rgba(69, 184, 121, 0.2)"
        },
        down: {
            main: "#E84553",
            darker: "rgba(232, 69, 83, 0.02)",
            lighter: "rgba(232, 69, 83, 0.2)"
        },
        table: {
            header: "#2D2C35",
            odd: "#171225"
        },
        symbol: {
            ceiling: "#f23aff",
            floor: "#00c9ff",
            reference: "#fdff12",
        }
    },
    light: {
        primary: "#2B80E4",
        secondary: "#dadfe6",
        transparent: "transparent",
        background: {
            default: "#FAFAFA",
            input: "#dadfe6",
            badge: "#dadfe6",
            app: "#e6e7ed",
            menu: "#34383E",
            backdrop: "#000000BF",
        },
        text: {
            primary: "#000000",
            secondary: "#8F8F92",
        },
        up: {
            main: "#45B879",
            darker: "rgba(69, 184, 121, 0.02)",
            lighter: "rgba(69, 184, 121, 0.2)"
        },
        down: {
            main: "#E84553",
            darker: "rgba(232, 69, 83, 0.02)",
            lighter: "rgba(232, 69, 83, 0.2)"
        },
        table: {
            header: "#00000066",
            odd: "#dadfe6",
            series: "#FFD700"
        },
        symbol: {
            ceiling: "#f23aff",
            floor: "#00c9ff",
            reference: "#fdff12",
        }
    },
}